module.exports = __webpack_public_path__ + "img/interface.d594f4b5.svg";